import { extractErrorMessage, useGetWellAllocationDetailsQuery, type WellAllocationRequest } from "@ots-frontend/ots-data";
import { skipToken } from "@reduxjs/toolkit/query";
import type { OtsBrand, OtsColorSchemePreference } from "../../theme/OtsTheme";
import { WellAllocationDialog } from "../WellAllocationDialog";

export type ConnectedWellAllocationDialogProps = {
  /** Open while set: the tank, time, and freight to allocate. */
  request?: WellAllocationRequest;
  onClose: () => void;
  volumeUnit?: string;
  density?: "comfortable" | "compact";
  brand?: OtsBrand;
  colorScheme?: OtsColorSchemePreference;
};

/** A ticket's well allocation, calculated by the production volumes service. */
export const ConnectedWellAllocationDialog = ({ request, onClose, volumeUnit, density, brand, colorScheme }: ConnectedWellAllocationDialogProps) => {
  const { data, error, isFetching, refetch } = useGetWellAllocationDetailsQuery(request ?? skipToken);
  return (
    <WellAllocationDialog
      open={!!request}
      onClose={onClose}
      details={data}
      loading={isFetching}
      error={error ? extractErrorMessage(error, "The well allocation could not be calculated.") : undefined}
      onRetry={() => { void refetch(); }}
      volumeUnit={volumeUnit}
      density={density}
      brand={brand}
      colorScheme={colorScheme}/>
  );
};
